<script setup>
const props = defineProps({
    value: String,
    item: Object
})
</script>

<template>
    <span v-html="value"/>
</template>